import axiosIns from '../../../../xaxios';
import { obtenerUrlAPICalificaciones } from '../utils/funciones';

const recurso = 'portal-solicitudes-calificaciones-nivelacion';

export default {

  /**
   * @param {object} filtros
   */
  async listar(filtros) {
    return await axiosIns.get(obtenerUrlAPICalificaciones(recurso), { params: filtros });
  },

  /**
   * @param {number} inscripcionModuloId
   */
  async listarPorInscripcionModulo(inscripcionModuloId) {
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/inscripcion-modulo/${inscripcionModuloId}`));
  },

  /**
   * @param {number} inscripcionModuloId
   */
  async listarPagosInscripcion(inscripcionModuloId) {
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/pagos-inscripcion/${inscripcionModuloId}`));
  },

  /**
   * @param {number} pagosInscripcionId
   */
  async obtenerPagoInscripcion(pagosInscripcionId) {
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/pagos-inscripcion/detalle/${pagosInscripcionId}`));
  },

  /**
   * @param {{ inscripcionModuloId: number, pagosInscripcionId: number, motivo?: string }} generarSolicitudInput
   */
  async generar(generarSolicitudInput) {
    return await axiosIns.post(obtenerUrlAPICalificaciones(`${recurso}/generar`), generarSolicitudInput);
  },

  /**
   * @param {{
   *   inscripcionModuloId: number,
   *   solicitudId?: number,
   *   nota: number,
   *   motivo?: string,
   *   documentoBase64?: string,
   * }} crearSolicitudInput
   */
  async crear(crearSolicitudInput) {
    return await axiosIns.post(obtenerUrlAPICalificaciones(recurso), crearSolicitudInput);
  },

  /**
   * @param {{ solicitudId: number, estadoSolicitud: string, observacionRevision?: string }} revisarSolicitudInput
   */
  async revisar(revisarSolicitudInput) {
    return await axiosIns.post(obtenerUrlAPICalificaciones(`${recurso}/revisar`), revisarSolicitudInput);
  },

  /**
   * @param {number} solicitudId
   */
  async visualizarSolicitud(solicitudId) {
    return await axiosIns.get(obtenerUrlAPICalificaciones(`${recurso}/visualizar-solicitud/${solicitudId}`));
  },

};
